import React, { useState, useEffect } from "react";
import { Button, CloseButton } from "react-bootstrap";
import { LuTickets } from "react-icons/lu";
import { RiPriceTag2Fill } from "react-icons/ri";
import {
  FaWpforms,
  FaCheck,
  FaExclamationCircle,
  FaArrowLeft,
  FaArrowRight,
} from "react-icons/fa";
import "react-datepicker/dist/react-datepicker.css";
import AddonsModal from "./AddonsModal";
import BasicTab from "./tabs/BasicTab";
import PricingTab from "./tabs/PricingTab";
import FormTab from "./tabs/FormTab";
import { useHistory } from "react-router-dom";
import { GetFormes, GetTaxSettings } from "../../../api/Webservices";
import { showToast, ToastMessage } from "../../Shared/ToastMessage";

const GuestTicketForm = ({
  show,
  onHide,
  onCreateGuestTicket,
  mainTicket,
  editMode = false,
  guestTicketToEdit = null,
  fetchAddons,
  addons,
  isLoadingAddons,
  selectedAddons,
  handleAddonSelection,
  setShowGuestTicketForm,
  setShowGuestTicket,
  setGuestTicket: setGuestTicketProps,
  setNotification: setNotificationProps,
  setShowAddOns,
  setGuestSelectedAddons,
  guestSelectedAddons,
}) => {
  const history = useHistory();
  const [errors, setErrors] = useState({
    name: "",
    currency: "",
    fixedPrice: "",
    variablePrice_0: "",
    selectedForm: "",
  });

  const [notification, setNotification] = useState({
    show: false,
    type: "",
    message: "",
  });

  const [showAddonsModal, setShowAddonsModal] = useState(false);

  const [guestTicket, setGuestTicket] = useState({
    name: "",
    qtyAvailable: "",
    description: "",
    group: "",
    selected_form: null,
    form_details: null,
    pricingType: "free",
    currency: mainTicket?.currency || "INR",
    priceOption: "fixed",
    fixedPrice: "",
    variablePrices: [{ price: "", validUntilDate: null, validUntilTime: null }],
    taxEnabled: false,
    taxIncluded: true,
    taxRate: "18",
    taxName: "GST",
    taxOptions: [],
    taxRegisTrationNumber: null,
    isPrivate: false,
    showSchedule: false,
    saleStartDate: null,
    saleStartTime: null,
    saleEndDate: null,
    saleEndTime: null,
    showLimits: true,
    ticket_min_order: "1",
    ticket_max_order: "6000",
    qrcode: false,
    ticketStatus: "onsale",
  });

  const [activeTab, setActiveTab] = useState("basic");
  const [showDescription, setShowDescription] = useState(false);
  const [showGroup, setShowGroup] = useState(false);

  const [formsList, setFormsList] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [isLoadingForms, setIsLoadingForms] = useState(false);
  const [showFormDropdown, setShowFormDropdown] = useState(false);

  const EventID = localStorage.getItem("eventId") || "";

  const fetchForms = async () => {
    setIsLoadingForms(true);
    try {
      const res = await GetFormes(EventID);
      if (!res || !res.data || !res.data.forms) {
        console.error("Invalid GetFormes response:", res);
        setFormsList([]);
        return;
      }
      const formsArray = res.data.forms;
      if (!Array.isArray(formsArray)) {
        console.error("forms is not an array:", formsArray);
        setFormsList([]);
        return;
      }
      const simplifiedForms = formsArray.map((formData) => {
        let parsedFields = [];
        if (formData.fileds) {
          try {
            let fieldsString = formData.fileds;
            if (
              typeof fieldsString === "string" &&
              fieldsString.startsWith('"') &&
              fieldsString.endsWith('"')
            ) {
              fieldsString = fieldsString.slice(1, -1);
            }
            fieldsString = fieldsString
              .replace(/\\"/g, '"')
              .replace(/\\\\/g, "\\")
              .replace(/\\n/g, "\n")
              .replace(/\\r/g, "\r")
              .replace(/\\t/g, "\t");
            parsedFields = JSON.parse(fieldsString);
          } catch (parseError) {
            console.error(
              "Error parsing fields for form",
              formData.id,
              ":",
              parseError
            );
            parsedFields = [];
          }
        }
        return {
          id: formData.id,
          name: formData.form_title || `Untitled Form ${formData.id}`,
          event_id: formData.event_id || EventID,
          form_type: formData.form_type || 1,
          form_id: formData.form_id,
          fields: parsedFields,
          description: formData.form_description || "",
          status: formData.status || "active",
          form_title: formData.form_title,
          form_description: formData.form_description,
        };
      });
      setFormsList(simplifiedForms);
    } catch (error) {
      console.error("Error fetching forms:", error);
      setFormsList([]);
    } finally {
      setIsLoadingForms(false);
    }
  };

  const fetchTaxSettings = async () => {
    try {
      const response = await GetTaxSettings(EventID);
      const settings = response?.data?.[0];
      let parsedTaxSettings = {};

      if (settings?.tax_settings) {
        try {
          parsedTaxSettings = JSON.parse(settings.tax_settings);
        } catch (err) {
          console.error("Error parsing tax_settings:", err);
        }
      }

      setGuestTicket((prev) => ({
        ...prev,
        taxOptions: parsedTaxSettings?.tax_options || [],
        taxRegisTrationNumber:
          parsedTaxSettings?.tax_registration_number || null,
        taxDisplay: parsedTaxSettings?.tax_display || "add_to_total",
      }));
    } catch (error) {
      console.error("Error fetching tax settings:", error);
    }
  };

  const handleFormSelect = (form) => {
    setSelectedForm(form);
    setGuestTicket({
      ...guestTicket,
      selected_form: form,
      form_details: form,
    });
  };

  const handleGuestAddonSelection = (addon) => {
    const isSelected = guestSelectedAddons.some((item) => item.id === addon.id);
    if (isSelected) {
      setGuestSelectedAddons(
        guestSelectedAddons.filter((item) => item.id !== addon.id)
      );
    } else {
      const selectedVariant =
        addon.hasVariants && addon.variants.length > 0
          ? addon.variants[0]
          : null;
      setGuestSelectedAddons([
        ...guestSelectedAddons,
        {
          ...addon,
          quantity: 1,
          isMandatory: false,
          selectedVariant: selectedVariant
            ? {
                name: selectedVariant.name,
                price: selectedVariant.price,
                variant_name:
                  selectedVariant.apiVariant?.variant_name ||
                  selectedVariant.name,
                variant_price:
                  selectedVariant.apiVariant?.variant_price ||
                  selectedVariant.price,
              }
            : null,
          tax_options: guestTicket.taxOptions,
        },
      ]);
    }
    // Update parent selectedAddons
    handleAddonSelection(addon);
  };

  const handleGuestRemoveAddon = (addonId) => {
    setGuestSelectedAddons(
      guestSelectedAddons.filter((addon) => addon.id !== addonId)
    );
    // Update parent selectedAddons
    const addonToRemove = guestSelectedAddons.find(
      (addon) => addon.id === addonId
    );
    if (addonToRemove) {
      handleAddonSelection(addonToRemove);
    }
  };

  const toggleGuestAddonMandatory = (addonId) => {
    setGuestSelectedAddons(
      guestSelectedAddons.map((addon) =>
        addon.id === addonId
          ? { ...addon, isMandatory: !addon.isMandatory }
          : addon
      )
    );
  };

  const handleGuestAddonQuantityChange = (addonId, quantity) => {
    setGuestSelectedAddons(
      guestSelectedAddons.map((addon) =>
        addon.id === addonId ? { ...addon, quantity } : addon
      )
    );
  };

  const handleGuestVariantSelection = (addonId, variantDetails) => {
    setGuestSelectedAddons(
      guestSelectedAddons.map((item) =>
        item.id === addonId
          ? {
              ...item,
              selectedVariant: {
                name: variantDetails.name,
                price: variantDetails.price,
                variant_name: variantDetails.name,
                variant_price: variantDetails.price,
              },
            }
          : item
      )
    );
  };

  const closeNotification = () => {
    setNotification({ ...notification, show: false });
  };

  const validateForm = (tab) => {
    let isValid = true;
    const newErrors = { ...errors };

    if (tab === "basic" || tab === "all") {
      if (!guestTicket.name.trim()) {
        newErrors.name = "Ticket name is required";
        isValid = false;
      } else {
        newErrors.name = "";
      }
    }

    if (
      (tab === "pricing" || tab === "all") &&
      guestTicket.pricingType === "paid"
    ) {
      if (!guestTicket.currency) {
        newErrors.currency = "Currency is required";
        isValid = false;
      } else {
        newErrors.currency = "";
      }

      // Validate price based on price option
      if (guestTicket.priceOption === "fixed") {
        const fixedPriceError = validatePrice(guestTicket.fixedPrice, "fixed price");
        if (fixedPriceError) {
          newErrors.fixedPrice = fixedPriceError;
          isValid = false;
        } else {
          newErrors.fixedPrice = "";
        }
      } else if (guestTicket.priceOption === "variable" && guestTicket.variablePrices && guestTicket.variablePrices.length > 0) {
        const firstPriceError = validatePrice(guestTicket.variablePrices[0].price, "price");
        if (firstPriceError) {
          newErrors.variablePrice_0 = firstPriceError;
          isValid = false;
        } else {
          newErrors.variablePrice_0 = "";
        }
      }
    }

    if (tab === "form" || tab === "all") {
      if (!selectedForm || !selectedForm.id) {
        newErrors.selectedForm = "Please select a form";
        isValid = false;
      } else {
        newErrors.selectedForm = "";
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  // Helper function for price validation
  const validatePrice = (value, fieldName = "price") => {
    const numValue = parseFloat(value);
    if (!value || value.trim() === "") {
      return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is required.`;
    }
    if (isNaN(numValue) || numValue <= 0) {
      return `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} must be a positive number.`;
    }
    return "";
  };

  useEffect(() => {
    if (editMode && guestTicketToEdit) {
      let formattedVariablePrices = [];
      if (
        guestTicketToEdit.variable_prices &&
        Array.isArray(guestTicketToEdit.variable_prices) &&
        guestTicketToEdit.variable_prices.length > 0
      ) {
        formattedVariablePrices = guestTicketToEdit.variable_prices.map(
          (price) => {
            let validDate = null;
            let validTime = null;
            if (price.valid_till) {
              try {
                const dateObj = new Date(price.valid_till);
                validDate = dateObj;
                validTime = dateObj;
              } catch (e) {
                console.error("Error parsing date:", e);
              }
            }
            return {
              price: price.price?.toString() || "",
              validUntilDate: validDate,
              validUntilTime: validTime,
            };
          }
        );
      } else {
        formattedVariablePrices = [
          { price: "", validUntilDate: null, validUntilTime: null },
        ];
      }

      let parsedFormDetails = null;
      if (guestTicketToEdit.form_details) {
        try {
          parsedFormDetails =
            typeof guestTicketToEdit.form_details === "string"
              ? JSON.parse(guestTicketToEdit.form_details)
              : guestTicketToEdit.form_details;
        } catch (error) {
          console.error("Error parsing form_details:", error);
          parsedFormDetails = null;
        }
      }

      const updatedGuestTicket = {
        name: guestTicketToEdit.ticket_name || guestTicketToEdit.name || "",
        qtyAvailable:
          guestTicketToEdit.quantity?.toString() ||
          guestTicketToEdit.qtyAvailable?.toString() ||
          "",
        description: guestTicketToEdit.description || "",
        group: guestTicketToEdit.ticket_group || guestTicketToEdit.group || "",
        selected_form: guestTicketToEdit.selected_form,
        form_details: parsedFormDetails,
        pricingType: guestTicketToEdit.pricingType,
        currency: guestTicketToEdit.currency || mainTicket?.currency || "INR",
        priceOption:
          guestTicketToEdit.pricing_option ||
          guestTicketToEdit.priceOption ||
          "fixed",
        fixedPrice:
          guestTicketToEdit.price?.toString() ||
          guestTicketToEdit.fixedPrice ||
          "",
        variablePrices: formattedVariablePrices,
        taxEnabled: guestTicketToEdit.tax_type !== "No Tax",
        taxIncluded: guestTicketToEdit.tax_type === "Including Tax",
        taxRate:
          (guestTicketToEdit.tax_options &&
            guestTicketToEdit.tax_options[0]?.tax_percentage?.toString()) ||
          "18",
        taxName:
          (guestTicketToEdit.tax_options &&
            guestTicketToEdit.tax_options[0]?.tax_name) ||
          "GST",
        taxOptions: guestTicketToEdit.tax_options || [],
        taxRegisTrationNumber:
          guestTicketToEdit.tax_registration_number || null,
        isPrivate: guestTicketToEdit.private_ticket === "yes",
        showSchedule: guestTicketToEdit.schedule_sale_enabled === "yes",
        saleStartDate: guestTicketToEdit.start_sale
          ? new Date(guestTicketToEdit.start_sale)
          : null,
        saleStartTime: guestTicketToEdit.start_sale
          ? new Date(guestTicketToEdit.start_sale)
          : null,
        saleEndDate: guestTicketToEdit.end_sale
          ? new Date(guestTicketToEdit.end_sale)
          : null,
        saleEndTime: guestTicketToEdit.end_sale
          ? new Date(guestTicketToEdit.end_sale)
          : null,
        showLimits:
          guestTicketToEdit.ticket_min_order !== undefined ||
          guestTicketToEdit.ticket_max_order !== undefined,
        ticket_min_order: guestTicketToEdit.ticket_min_order?.toString() || "1",
        ticket_max_order:
          guestTicketToEdit.ticket_max_order?.toString() || "6000",
        qrcode: guestTicketToEdit.qrcode === "yes",
        ticketStatus: guestTicketToEdit.ticket_status || "onsale",
      };

      setGuestTicket(updatedGuestTicket);

      if (parsedFormDetails) {
        setSelectedForm(parsedFormDetails);
      }

      if (guestTicketToEdit.description) {
        setShowDescription(true);
      }
      if (guestTicketToEdit.ticket_group || guestTicketToEdit.group) {
        setShowGroup(true);
      }

      // Initialize guestSelectedAddons with add-ons from guestTicketToEdit
      if (guestTicketToEdit.addons && Array.isArray(guestTicketToEdit.addons)) {
        const formattedAddons = guestTicketToEdit.addons.map((addon) => ({
          id: addon.id,
          name: addon.add_on_name || addon.name || "",
          description: addon.description || "",
          price:
            addon.price ||
            (addon.variant_options?.length > 0
              ? addon.variant_options[0].variant_price
              : 0),
          currency: addon.currency || "INR",
          variants: Array.isArray(addon.variant_options)
            ? addon.variant_options.map((v) => ({
                name: v.variant_name || "",
                quantity: v.quantity_available || 0,
                price: v.variant_price || 0,
                apiVariant: {
                  variant_name: v.variant_name || "",
                  quantity_available: v.quantity_available || 0,
                  variant_price: v.variant_price || 0,
                },
              }))
            : [],
          hasVariants: addon.variant_options?.length > 0,
          type: addon.addons_type || addon.type || "single",
          status: addon.addon_status || addon.status || "onsale",
          quantity: addon.quantity || 1,
          isMandatory: addon.is_mandatory || addon.isMandatory || false,
          selectedVariant:
            addon.variant_options?.length > 0
              ? {
                  name: addon.variant_options[0].variant_name,
                  price: addon.variant_options[0].variant_price,
                  variant_name: addon.variant_options[0].variant_name,
                  variant_price: addon.variant_options[0].variant_price,
                }
              : null,
          tax_type: addon.tax_type || "Including Tax",
          tax_options: addon.tax_options || updatedGuestTicket.taxOptions,
        }));
        setGuestSelectedAddons(formattedAddons);
      }
    } else if (!editMode) {
      setGuestTicket({
        name: "",
        qtyAvailable: "",
        description: "",
        group: "",
        selected_form: null,
        form_details: null,
        pricingType: "free",
        currency: mainTicket?.currency || "INR",
        priceOption: "fixed",
        fixedPrice: "",
        variablePrices: [
          { price: "", validUntilDate: null, validUntilTime: null },
        ],
        taxEnabled: false,
        taxIncluded: true,
        taxRate: "18",
        taxName: "GST",
        taxOptions: [],
        taxRegisTrationNumber: null,
        isPrivate: false,
        showSchedule: false,
        saleStartDate: null,
        saleStartTime: null,
        saleEndDate: null,
        saleEndTime: null,
        showLimits: true,
        ticket_min_order: "1",
        ticket_max_order: "6000",
        qrcode: false,
        ticketStatus: "onsale",
      });
      setShowDescription(false);
      setShowGroup(false);
      setGuestSelectedAddons([]);
    }
  }, [editMode, guestTicketToEdit, mainTicket]);

  useEffect(() => {
    fetchForms();
    fetchTaxSettings();
  }, [EventID]);

  const handleCreateGuestTicket = () => {
    if (validateForm("all")) {
      try {
        const guestTicketData = {
          ticket_name: guestTicket.name,
          description: guestTicket.description || "",
          price:
            guestTicket.pricingType === "paid"
              ? guestTicket.priceOption === "fixed"
                ? Number.parseFloat(guestTicket.fixedPrice)
                : Number.parseFloat(guestTicket.variablePrices[0]?.price || 0)
              : null,
          quantity: guestTicket.qtyAvailable
            ? Number.parseInt(guestTicket.qtyAvailable)
            : 50,
          start_sale: mainTicket?.saleStartDate
            ? `${
                new Date(mainTicket.saleStartDate).toISOString().split("T")[0]
              } ${
                mainTicket.saleStartTime
                  ? new Date(mainTicket.saleStartTime)
                      .toTimeString()
                      .split(" ")[0]
                  : "00:00:00"
              }`
            : null,
          end_sale: mainTicket?.saleEndDate
            ? `${
                new Date(mainTicket.saleEndDate).toISOString().split("T")[0]
              } ${
                mainTicket.saleEndTime
                  ? new Date(mainTicket.saleEndTime)
                      .toTimeString()
                      .split(" ")[0]
                  : "23:59:59"
              }`
            : null,
          ticket_min_order: Number.parseInt(guestTicket.ticket_min_order) || 1,
          ticket_max_order:
            Number.parseInt(guestTicket.ticket_max_order) || 6000,
          ticket_type: guestTicket.pricingType,
          ticket_group: guestTicket.group || null,
          selected_form: guestTicket.selected_form?.id || null,
          form_details: guestTicket.form_details || null,
          private_ticket: guestTicket.isPrivate ? "yes" : "no",
          qrcode: guestTicket.qrcode ? "yes" : "no",
          ticket_status: guestTicket.ticketStatus,
          currency: guestTicket.currency,
          pricing_option: guestTicket.priceOption,
          variable_prices:
            guestTicket.priceOption === "variable"
              ? guestTicket.variablePrices.map((vp) => ({
                  price: Number.parseFloat(vp.price) || 0,
                  valid_till: vp.validUntilDate
                    ? `${
                        new Date(vp.validUntilDate).toISOString().split("T")[0]
                      } ${
                        vp.validUntilTime
                          ? new Date(vp.validUntilTime)
                              .toTimeString()
                              .split(" ")[0]
                          : "23:59:59"
                      }`
                    : null,
                }))
              : null,
          tax_type: guestTicket.taxEnabled
            ? guestTicket.taxIncluded
              ? "Including Tax"
              : "Excluding Tax"
            : "No Tax",
          tax_options: guestTicket.taxEnabled
            ? guestTicket.taxOptions || []
            : [],
          tax_registration_number: guestTicket.taxRegisTrationNumber || null,
          schedule_sale_enabled: guestTicket.showSchedule ? "yes" : "no",
          addons: guestSelectedAddons.map((addon) => ({
            id: addon.id,
            user_id: 1,
            event_id: EventID,
            isMandatory: addon.isMandatory || false,
            addons_type: addon.type || "single",
            add_on_name: addon.name,
            description: addon.description || "",
            price_type: addon.price_type || "paid",
            price:
              Number.parseFloat(addon.price) ||
              (addon.selectedVariant
                ? Number.parseFloat(addon.selectedVariant.variant_price)
                : 0),
            currency: addon.currency || "INR",
            tax_type: addon.tax_type || "Including Tax",
            tax_options: addon.tax_options || guestTicket.taxOptions,
            variant_options: Array.isArray(addon.variants)
              ? addon.variants.map((variant) => ({
                  variant_name:
                    variant.apiVariant?.variant_name || variant.name,
                  quantity_available:
                    variant.apiVariant?.quantity_available || variant.quantity,
                  variant_price:
                    variant.apiVariant?.variant_price || variant.price,
                }))
              : [],
            selected_variant: addon.selectedVariant
              ? {
                  variant_name: addon.selectedVariant.variant_name,
                  variant_price: addon.selectedVariant.variant_price,
                }
              : null,
            quantity: addon.quantity || 1,
            addon_status: addon.status || "onsale",
            created_at: addon.created_at || new Date().toISOString(),
          })),
        };

        // Create the full ticket data including guest_details
        const fullTicketData = {
          ...mainTicket,
          guest_details: guestTicketData,
        };

        onCreateGuestTicket(
          guestTicketData,
          fullTicketData,
          editMode ? guestTicketToEdit?.id : null
        );
        setGuestTicketProps(guestTicketData);
        // setNotificationProps({
        //   show: true,
        //   type: "success",
        //   message: editMode
        //     ? "Guest ticket updated successfully!"
        //     : "Guest ticket created successfully!",
        // });
        showToast(editMode
          ? "Guest ticket updated successfully!"
          : "Guest ticket created successfully!", "success");
      } catch (error) {
        console.error("Error creating/updating guest ticket:", error);
        // setNotificationProps({
        //   show: true,
        //   type: "error",
        //   message: "Failed to create/update guest ticket. Please try again.",
        // });
        showToast("Failed to create/update guest ticket. Please try again.", "error");
      }
    } else {
      showToast("Please fill all required fields", "error");
      // setNotification({
      //   show: true,
      //   type: "error",
      //   message: "Please fill all required fields.",
      // });
    }
  };

  const handleNext = () => {
    if (validateForm(activeTab)) {
      if (activeTab === "basic") {
        setActiveTab("pricing");
      } else if (activeTab === "pricing") {
        setActiveTab("form");
      } else if (activeTab === "form") {
        handleCreateGuestTicket();
      }
    }else{
      showToast("Please fill all required fields", "error");
    }
  };

  return (
    <div
      className={`guest-ticket-form ${show ? "show" : ""}`}
      style={{
        position: "fixed",
        top: 0,
        right: show ? 0 : "-100%",
        width: "100%",
        maxWidth: "500px",
        height: "100vh",
        backgroundColor: "#ffffff",
        boxShadow: "-4px 0 20px rgba(0, 0, 0, 0.15)",
        zIndex: 1050,
        transition: "right 0.3s ease-in-out",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <ToastMessage/>
      {notification.show && (
        <div
          className={`notification-banner ${notification.type} d-flex align-items-center justify-content-between`}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            padding: "12px 20px",
            backgroundColor:
              notification.type === "success" ? "#d4edda" : "#f8d7da",
            color: notification.type === "success" ? "#155724" : "#721c24",
            borderBottom: `3px solid ${
              notification.type === "success" ? "#28a745" : "#dc3545"
            }`,
            zIndex: 1051,
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          <div className="d-flex align-items-center">
            {notification.type === "success" ? (
              <FaCheck className="me-2" style={{ color: "#28a745" }} />
            ) : (
              <FaExclamationCircle
                className="me-2"
                style={{ color: "#dc3545" }}
              />
            )}
            {notification.message}
          </div>
          <CloseButton
            onClick={closeNotification}
            style={{
              fontSize: "12px",
              opacity: 0.7,
            }}
          />
        </div>
      )}

      <div
        className="create-ticket-container"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          paddingTop: notification.show ? "60px" : "0",
        }}
      >
        {/* Header */}
        <div
          className="create-ticket-header d-flex justify-content-between align-items-center"
          style={{
            padding: "24px 24px 20px",
            borderBottom: "1px solid #e9ecef",
            backgroundColor: "#ffffff",
            flexShrink: 0,
          }}
        >
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: "20px",
                fontWeight: "600",
                color: "#184778",
              }}
            >
              {editMode ? "Edit Guest Ticket" : "Create Guest Ticket"}
            </h3>
            <p
              style={{
                margin: "4px 0 0",
                fontSize: "14px",
                color: "#6c757d",
              }}
            >
              {activeTab === "basic" && "Set up basic ticket information"}
              {activeTab === "pricing" && "Configure pricing and tax settings"}
              {activeTab === "form" && "Attach registration form"}
            </p>
          </div>
          <button
            onClick={() => setShowGuestTicketForm(false)}
            className="search_toggle btn btn-danger"
          >
            <i className="fa fa-times"></i>
          </button>
        </div>

        {/* Tab Navigation */}
        <div
          className="tab-navigation-container"
          style={{
            padding: "0 24px",
            backgroundColor: "#ffffff",
            borderBottom: "1px solid #e9ecef",
            flexShrink: 0,
          }}
        >
          <div
            className="tab-navigation"
            style={{
              display: "flex",
              gap: "0",
              marginBottom: "16px",
              marginTop: "16px",
            }}
          >
            {[
              {
                key: "basic",
                icon: LuTickets,
                label: "Basic",
                description: "Ticket details",
              },
              {
                key: "pricing",
                icon: RiPriceTag2Fill,
                label: "Pricing",
                description: "Price & tax",
              },
              {
                key: "form",
                icon: FaWpforms,
                label: "Form",
                description: "Registration",
              },
            ].map((tab, index) => (
              <button
                key={tab.key}
                className={`tab-button ${
                  activeTab === tab.key ? "active" : ""
                }`}
                onClick={() => {
                  if (tab.key === "basic") {
                    setActiveTab("basic");
                  } else if (tab.key === "pricing") {
                    if (validateForm("basic")) {
                      setActiveTab("pricing");
                    }else{
                      showToast("Please fill all required fields", "error");
                    }
                  } else if (tab.key === "form") {
                    if (validateForm("basic") && validateForm("pricing")) {
                      setActiveTab("form");
                    }else{
                      showToast("Please fill all required fields", "error");
                    }
                  }
                }}
                style={{
                  flex: 1,
                  padding: "10px 35px",
                  border: "none",
                  backgroundColor:
                    activeTab === tab.key ? "#184778" : "transparent",
                  color: activeTab === tab.key ? "#ffffff" : "#6c757d",
                  borderBottom:
                    activeTab === tab.key
                      ? "3px solid #184778"
                      : "3px solid transparent",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  fontSize: "14px",
                  fontWeight: "500",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "4px",
                  position: "relative",
                  borderRadius: "30px",
                }}
                onMouseEnter={(e) => {
                  if (activeTab !== tab.key) {
                    e.target.style.backgroundColor = "#f8f9fa";
                    e.target.style.color = "#184778";
                  }
                }}
                onMouseLeave={(e) => {
                  if (activeTab !== tab.key) {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "#6c757d";
                  }
                }}
              >
                <tab.icon size={18} />
                <span style={{ fontSize: "12px", fontWeight: "600" }}>
                  {tab.label}
                </span>
                {index < 2 && (
                  <div
                    style={{
                      position: "absolute",
                      right: "-1px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "1px",
                      height: "24px",
                      backgroundColor: "#e9ecef",
                    }}
                  />
                )}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div
          className="create-ticket-body"
          style={{
            flex: 1,
            overflow: "auto",
            padding: "24px",
            backgroundColor: "#f8f9fa",
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "8px",
              padding: "24px",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
              border: "1px solid #e9ecef",
            }}
          >
            {activeTab === "basic" && (
              <BasicTab
                newTicket={guestTicket}
                setNewTicket={setGuestTicket}
                errors={errors}
                setErrors={setErrors}
                showDescription={showDescription}
                setShowDescription={setShowDescription}
                showGroup={showGroup}
                setShowGroup={setShowGroup}
                selectedAddons={guestSelectedAddons}
                handleRemoveAddon={handleGuestRemoveAddon}
                toggleAddonMandatory={toggleGuestAddonMandatory}
                handleAddonQuantityChange={handleGuestAddonQuantityChange}
                fetchAddons={fetchAddons}
                setShowAddonsModal={setShowAddonsModal}
                handleVariantSelection={handleGuestVariantSelection}
              />
            )}

            {activeTab === "pricing" && (
              <PricingTab
                newTicket={guestTicket}
                setNewTicket={setGuestTicket}
                errors={errors}
                setErrors={setErrors}
                handleAddVariablePrice={() => {
                  setGuestTicket({
                    ...guestTicket,
                    variablePrices: Array.isArray(guestTicket.variablePrices)
                      ? [
                          ...guestTicket.variablePrices,
                          {
                            price: "",
                            validUntilDate: null,
                            validUntilTime: null,
                          },
                        ]
                      : [
                          {
                            price: "",
                            validUntilDate: null,
                            validUntilTime: null,
                          },
                        ],
                  });
                }}
                handleVariablePriceChange={(index, field, value) => {
                  if (!Array.isArray(guestTicket.variablePrices)) {
                    setGuestTicket({
                      ...guestTicket,
                      variablePrices: [
                        {
                          price: "",
                          validUntilDate: null,
                          validUntilTime: null,
                        },
                      ],
                    });
                    return;
                  }
                  const updatedPrices = [...guestTicket.variablePrices];
                  updatedPrices[index] = {
                    ...updatedPrices[index],
                    [field]: value,
                  };
                  setGuestTicket({
                    ...guestTicket,
                    variablePrices: updatedPrices,
                  });
                }}
                handleDeleteVariablePrice={(index) => {
                  const updatedPrices = [...guestTicket.variablePrices];
                  updatedPrices.splice(index, 1);
                  setGuestTicket({
                    ...guestTicket,
                    variablePrices: updatedPrices,
                  });
                }}
                handleDateChange={(index, date) => {
                  const updatedPrices = [...guestTicket.variablePrices];
                  updatedPrices[index] = {
                    ...updatedPrices[index],
                    validUntilDate: date,
                  };
                  setGuestTicket({
                    ...guestTicket,
                    variablePrices: updatedPrices,
                  });
                }}
                handleTimeChange={(index, time) => {
                  const updatedPrices = [...guestTicket.variablePrices];
                  updatedPrices[index] = {
                    ...updatedPrices[index],
                    validUntilTime: time,
                  };
                  setGuestTicket({
                    ...guestTicket,
                    variablePrices: updatedPrices,
                  });
                }}
                isGuestTicket={true}
              />
            )}

            {activeTab === "form" && (
              <FormTab
                selectedForm={selectedForm}
                setSelectedForm={setSelectedForm}
                handleFormSelect={handleFormSelect}
                EventID={EventID}
                setNewTicket={setGuestTicket}
                formsList={formsList}
                isLoadingForms={isLoadingForms}
                newTicket={guestTicket}
                errors={errors}
                setErrors={setErrors}
              />
            )}
          </div>
        </div>

        {/* Footer */}
        <div
          className="create-ticket-footer d-flex justify-content-between"
          style={{
            padding: "20px 24px",
            borderTop: "1px solid #e9ecef",
            backgroundColor: "#ffffff",
            flexShrink: 0,
          }}
        >
          <Button
            variant="light"
            onClick={() => {
              if (activeTab === "basic") {
                setShowGuestTicketForm(false);
              } else if (activeTab === "pricing") {
                setActiveTab("basic");
              } else if (activeTab === "form") {
                setActiveTab("pricing");
              }
            }}
            style={{
              padding: "10px 20px",
              border: "1px solid #dee2e6",
              backgroundColor: "#ffffff",
              color: "#6c757d",
              fontWeight: "500",
              borderRadius: "6px",
              transition: "all 0.2s ease",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#f8f9fa";
              e.target.style.borderColor = "#adb5bd";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#ffffff";
              e.target.style.borderColor = "#dee2e6";
            }}
          >
            <FaArrowLeft size={14} />
            {activeTab === "basic" ? "Cancel" : "Back"}
          </Button>

          <div className="d-flex gap-2">
            {activeTab === "form" ? (
              <Button
                variant="primary"
                onClick={handleCreateGuestTicket}
                style={{
                  padding: "10px 24px",
                  backgroundColor: "#184778",
                  borderColor: "#184778",
                  fontWeight: "600",
                  borderRadius: "6px",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#31719c";
                  e.target.style.borderColor = "#31719c";
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#184778";
                  e.target.style.borderColor = "#184778";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                <FaCheck size={14} />
                {editMode ? "Update Ticket" : "Publish & Start Sale"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={handleNext}
                style={{
                  padding: "10px 24px",
                  backgroundColor: "#184778",
                  borderColor: "#184778",
                  fontWeight: "600",
                  borderRadius: "6px",
                  transition: "all 0.2s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#31719c";
                  e.target.style.borderColor = "#31719c";
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#184778";
                  e.target.style.borderColor = "#184778";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                Next
                <FaArrowRight size={14} />
              </Button>
            )}
          </div>
        </div>
      </div>

      <AddonsModal
        isOpen={showAddonsModal}
        onClose={() => setShowAddonsModal(false)}
        addons={addons}
        isLoadingAddons={isLoadingAddons}
        selectedAddons={guestSelectedAddons}
        handleAddonSelection={handleGuestAddonSelection}
        toggleMandatory={toggleGuestAddonMandatory}
        handleQuantityChange={handleGuestAddonQuantityChange}
        handleVariantSelection={handleGuestVariantSelection}
        handleRemoveAddon={handleGuestRemoveAddon}
      />
    </div>
  );
};

export default GuestTicketForm;